import { makeStyles } from "@mui/styles";
import BaseColor from "../../Config/Color";

const styles = makeStyles((theme) => ({
  formContainer: {
    padding: theme.spacing(2),
    maxWidth: "80vw",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },

  formSection: {
    padding: theme.spacing(3),
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    marginBottom: theme.spacing(3),
    transition: "box-shadow 0.3s ease",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0),
      marginBottom: theme.spacing(2),
    },
  },

  formTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },

  sectionTitle: {
    fontWeight: 600,
    color: BaseColor.primary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
  },

  formSubtitle: {
    marginBottom: theme.spacing(3),
    color: BaseColor.textSecondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      marginBottom: theme.spacing(2),
    },
  },

  formControl: {
    marginBottom: theme.spacing(2),
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1.5),
    },
  },

  textarea: {
    width: "100%",
    padding: "16.5px 14px",
    borderRadius: "4px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    fontFamily: "inherit",
  },


  addressSelect: {
    width: "100%",
  },

  formLabel: {
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    color: BaseColor.textPrimary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
    },
  },

  formGroup: {
    display: "flex",
    flexWrap: "wrap",
  },

  formControlLabel: {
    marginRight: theme.spacing(2),
    "& .MuiFormControlLabel-label": {
      fontSize: "0.9rem",
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(1),
      "& .MuiFormControlLabel-label": {
        fontSize: "0.85rem",
      },
    },
  },

  submitButton: {
    marginTop: theme.spacing(3),
    backgroundColor: BaseColor.primary,
    color: "#fff",
    padding: "10px 24px",
    "&:hover": {
      backgroundColor: BaseColor.primaryDark,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: theme.spacing(2),
    },
  },

  radioGroup: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },

  select: {
    minWidth: "100%",
  },

  stepperContainer: {
    marginBottom: theme.breakpoints.down("sm")
      ? theme.spacing(2)
      : theme.spacing(4),
  },

  mediaUploadBox: {
    border: `1px dashed ${BaseColor.primary}`,
    borderRadius: "8px",
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    backgroundColor: "rgba(0,0,0,0.02)",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },

  buttonContained: {
    backgroundColor: BaseColor.primary,
    color: "#fff",
    "&:hover": {
      backgroundColor: BaseColor.primaryDark,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  buttonOutlined: {
    borderColor: BaseColor.primary,
    color: BaseColor.primary,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  chipItem: {
    margin: theme.spacing(0.5),
  },

  // New responsive styles
  mobileGrid: {
    [theme.breakpoints.down("sm")]: {
      "& .MuiGrid-item": {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
  },

  mobileStack: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },

  mobileTypography: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
      textAlign: "center",
    },
  },

  mobileInputAdornment: {
    [theme.breakpoints.down("sm")]: {
      "& .MuiSvgIcon-root": {
        fontSize: "1.2rem",
      },
    },
  },

  phoneFieldContainer: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(1),
    },
  },

  phoneCodeContainer: {
    minWidth: 120,
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },

  phoneNumberContainer: {
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

export default styles;
